"use client";

import {
  SMARTSHEET_READ_TOOLS,
  SMARTSHEET_WRITE_TOOLS,
} from "@workspace/connectors/definitions";
import { lazy } from "react";
import { createMcpToolRegistry } from "../mcp-tool-registry";

const smartsheetMcpToolView = lazy(() =>
  import("./tool-view").then(({ SmartsheetMcpToolView }) => ({
    default: SmartsheetMcpToolView,
  }))
);

/**
 * Smartsheet is an MCP + progressive-disclosure capability — its tool parts
 * arrive as `smartsheet_${mcpToolName}`. See `createMcpToolRegistry`.
 */
export const smartsheetToolRegistry = createMcpToolRegistry({
  prefix: "smartsheet",
  readTools: SMARTSHEET_READ_TOOLS,
  writeTools: SMARTSHEET_WRITE_TOOLS,
  view: smartsheetMcpToolView,
});
